export default "__VITE_ASSET__B3bHROpH__"